// @ts-nocheck
class WIblog extends HTMLElement {
    constructor () {
        super();
    }

    connectedCallback() {
        this.clickOnBlogOption();    
    }

    // click on blog options
    clickOnBlogOption() {
        let blogButtons = this.querySelectorAll('.WI_blogPage_head button');
        let blogCard = this.querySelectorAll('.WI_blogPage_body_in_body');
        blogButtons.forEach(b => {
            b.addEventListener('click', ()=>{
                blogButtons.forEach(bDemo => {
                    bDemo.classList.remove('WI_blog_option_active');
                });
                b.classList.add('WI_blog_option_active');
                let bId = b.getAttribute('data-id');
                if (bId == "all") {
                    blogCard.forEach(bC => {
                        bC.style.display = "block"
                    });
                }else{
                    blogCard.forEach(bC => {
                        bC.style.display = "none"
                        let bdData = bC.getAttribute('data-id');
                        if (bId == bdData) {
                            bC.style.display = "block";
                        }
                    });
                }
            });
        });
    }

} 

customElements.define('wi-blog-page',WIblog);